import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Children, memo, useMemo, } from 'react';
import Masonry from 'react-masonry-css';
import { defaultBreakpointsPixels, } from '../../styles/media';
const masonryGridStyles = css `
  display: flex;
  width: 100%;
`;
const MasonryGrid = ({ children, columns, }) => {
    const breakpointColumns = useMemo(() => (Object
        .keys(columns)
        .reduce((masonryBreakpoints, breakpoint) => {
        const pixelSize = (breakpoint === 'default'
            ? 'default'
            : defaultBreakpointsPixels[breakpoint]);
        const numOfColumns = columns[breakpoint];
        return Object.assign(Object.assign({}, masonryBreakpoints), { [pixelSize]: numOfColumns });
    }, {})), [
        columns,
    ]);
    return (_jsx(Masonry, Object.assign({ breakpointCols: breakpointColumns, className: "", columnClassName: "", css: masonryGridStyles }, { children: Children.toArray(children) })));
};
const MemoizedMasonryGrid = memo(MasonryGrid);
export { MemoizedMasonryGrid as MasonryGrid };
// MC-1068 Temporary hack for Storybook.
export default MasonryGrid;
